import * as yup from 'yup';
import { phoneRegExp } from '../../../helpers/regex';

const withoutEmployeeId = text => ({
  is: value => value == null,
  then: yup.string().required(text),
});

export const validations = yup.object().shape({
  employeeId: yup
    .number()
    .nullable(),
  profileId: yup
    .number()
    .required('Escolha o perfil do usuário')
    .nullable(),
  name: yup
    .string()
    .required('O nome é obrigatório'),
  email: yup
    .string()
    .transform(email => email.replace(/ /g, ''))
    .email('O e-mail precisa ser válido')
    .required('O e-mail é obrigatório'),
  phone: yup
    .string()
    .when(['mainUser'], {
      is: mainUser => +mainUser == 1,
      then: yup
        .string()
        .required('O telefone é obrigatório')
        .matches(phoneRegExp, 'O telefone precisa ser válido')
    }),
  status: yup
    .bool(),
  password: yup
    .string()
    .when('employeeId', withoutEmployeeId('A senha é obrigatória'))
    .test(function(password) {
      if(!!this.parent.employeeId) {
        return true;
      }

      if(!password) {
        return this.createError({
          message: 'A senha é obrigatória',
          path: 'password'
        });
      }

      if(!/^(?=.*[A-Z]).+$/.test(password)) {
        return this.createError({
          message: 'Pelo menos 1 letra maiúscula (A-Z)',
          path: 'password'
        });
      }

      if(!/^(?=.*[a-z]).+$/.test(password)) {
        return this.createError({
          message: 'Pelo menos 1 letra minúscula (a-z)',
          path: 'password'
        });
      }

      if(!/^(?=.*\d).+$/.test(password)) {
        return this.createError({
          message: 'Pelo menos 1 número (0-9)',
          path: 'password'
        });
      }

      if(!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
        return this.createError({
          message: 'Pelo menos 1 caractere especial',
          path: 'password'
        });
      }

      if(password?.length < 8) {
        return this.createError({
          message: 'Mínimo de 8 caracteres',
          path: 'password'
        });
      }

      return true;
    }),
  passwordConfirm: yup
    .string()
    .when('password', (password, schema) => password ? schema.required('Confirme a senha') : schema)
    .oneOf([yup.ref('password'), null], 'A senha e a confirmação devem ser iguais'),
  establishments: yup
    .array()
    .nullable()
    .required('Escolha o(s) estabelecimento(s) para vincular a conta'),
  userRestrictions: yup
    .array()
    .nullable()
});

export const mainUserValidations = yup.object().shape({
  reason: yup
    .string()
    .required('O motivo é obrigatório'),
  password: yup
    .string()
    .required('A senha é obrigatória')
});